import { memo } from 'react'

import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { InputAdornment } from '@mui/material'

const CustomAutoComplete = ({
  label,
  onChange,
  placeholder,
  help,
  success,
  error,
  startIcon,
  ...restProps
}) => {
  return (
    <Autocomplete
      autoHighlight
      getOptionLabel={(option) => option?.label || ''}
      onChange={(_, opt) => {
        onChange(opt?.value || '')
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={!!error}
          helperText={error || success || help}
          slotProps={{
            input: {
              ...params.InputProps,
              startAdornment: startIcon && (
                <InputAdornment position='start'>{startIcon}</InputAdornment>
              )
            },
            formHelperText: {
              sx: {
                color: success && 'success.main'
              }
            },
            inputLabel: { shrink: true },
            htmlInput: {
              ...params.inputProps,
              autoComplete: 'off'
            }
          }}
        />
      )}
      {...restProps}
    />
  )
}

export default memo(CustomAutoComplete)
